import { Chip, ChipProps, Stack } from '@mui/material';

type LabelWithBadgeProps = {
  label: string;
  badge: ChipProps['label'];
};

export const LabelWithBadge = (props: LabelWithBadgeProps) => {
  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      {props.label}
      <Chip color="primary" label={props.badge} size="small" />
    </Stack>
  );
};
